import styles from './OptionButtons.module.scss';

interface Props {
  icon: React.ReactNode;
  text: string;
  second_text?: string;
  selected: boolean;
  onClick: () => void;
}

const OptionButtons = ({
  icon,
  text,
  second_text,
  selected,
  onClick,
}: Props) => {
  return (
    <div
      onClick={onClick}
      className={`${styles.wrapper} ${selected ? styles.selected : ''}`}
    >
      <div className={styles.columnWrapper}>
        {icon} <span className={styles.text}>{text}</span>
      </div>
      {second_text && (
        <span className={`${styles.text} ${styles.second_text}`}>
          {second_text}
        </span>
      )}
    </div>
  );
};

export default OptionButtons;
